"use client";

import { m } from "framer-motion";

interface AnimatedPageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export default function AnimatedPageHeader({ title, subtitle, children }: AnimatedPageHeaderProps) {
  return (
    <div className="relative mx-auto flex w-full flex-col items-center justify-center space-y-4 text-center">
      <div className="space-y-4">
        <m.h1
          initial={{ opacity: 0, y: 20, filter: "blur(10px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="text-foreground text-3xl font-black uppercase md:text-4xl lg:text-5xl"
        >
          {title}
        </m.h1>
        {subtitle && (
          <m.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
            className="flex items-center justify-center gap-3"
          >
            <div className="via-foreground/30 h-px w-8 bg-gradient-to-r from-transparent to-transparent" />
            <p className="text-muted-foreground text-[9px] font-bold tracking-[0.4em] uppercase md:text-[10px]">
              {subtitle}
            </p>
            <div className="via-foreground/30 h-px w-8 bg-gradient-to-r from-transparent to-transparent" />
          </m.div>
        )}
      </div>
      {children && (
        <m.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="w-full"
        >
          {children}
        </m.div>
      )}
    </div>
  );
}
